import { lazy } from 'react'

import Header from "./components/Header/Header";
import MainContent from "./components/MainContent/MainContent";

const Modal = lazy(() => import("./components/Modal/Modal"));
const LearnMoreModal = lazy(() => import("./components/Modal/LearnMoreModal"));
const Footer = lazy(() => import("./components/Footer/Footer"));

function App() {
  return (
    <div className="app-wrapper">
      <Modal />
      <LearnMoreModal />
      <Header />
      <MainContent />
      <Footer />
    </div>
  );
}

export default App;
